module.exports = __webpack_public_path__ + "static/media/trial1.78b1272a.mp3";